export default {
  APP_LOADED: 'APP_LOADED',
  TIME_SPENT: 'TIME_SPENT',
  CONTENT_OPENED: 'CONTENT_OPENED',
  NOTIFICATION_PRESSED: 'NOTIFICATION_PRESSED',
  VIEWED_PROFILE: 'VIEWED_PROFILE',
  USER_LOGGED_OUT: 'USER_LOGGED_OUT',
  SWITCHED_TO_ADMIN: 'SWITCHED_TO_ADMIN',
  SWITCHED_TO_LEARNER: 'SWITCHED_TO_LEARNER',
  HOME_CLICKED: 'HOME_CLICKED',
  LIBRARY_CLICKED: 'LIBRARY_CLICKED',
  CHANNELS_CLICKED: 'CHANNELS_CLICKED',
  CALENDAR_CLICKED: 'CALENDAR_CLICKED',
  MY_TEAM_CLICKED: 'MY_TEAM_CLICKED',
  REPORTING_DASHBOARDS_CLICKED: 'REPORTING_DASHBOARDS_CLICKED',
  TEXT_SEARCHED: 'TEXT_SEARCHED',
  RESPONSE_SUBMITTED: 'RESPONSE_SUBMITTED',
  CARD_OPENED: 'CARD_OPENED'
};
